import React from 'react';
import { Box, Theme, withStyles } from '@material-ui/core';
import FsIconButton from 'ui-elements/buttons/FsIconButton';

export const PageWrapper = withStyles(({ spacing, breakpoints }: Theme) => ({
  root: {
    maxWidth: 1095,
    margin: '0 auto',
    padding: spacing(0, 1),
    [breakpoints.up('sm')]: {
      padding: spacing(0, 3),
    },
  },
}))((props) => <Box {...props} />);

export const NotificationIconButton = withStyles(({ palette }) => ({
  root: {
    color: palette.common.white,
    '& svg': {
      margin: 0,
    },
  },
}))(FsIconButton);

export default PageWrapper;
